import { Component } from '@angular/core';
import { NavbarComponent } from './components/navbar/navbar';
import { HeroComponent } from './components/hero/hero';
import { WordsStripComponent } from './components/words-strip/words-strip';
import { AboutComponent } from './components/about/about';
import { ServicesComponent } from './components/services/services';
import { TalleresComponent } from './components/talleres/talleres';
import { ColaboracionesComponent } from './components/colaboraciones/colaboraciones';
import { TestimonialsComponent } from './components/testimonials/testimonials';
import { FaqsComponent } from './components/faqs/faqs';
import { CtaComponent } from './components/cta/cta';
import { ImagesStripComponent } from './components/images-strip/images-strip';
import { ContactComponent } from './components/contact/contact';
import { FooterComponent } from './components/footer/footer';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    NavbarComponent,
    HeroComponent,
    WordsStripComponent,
    AboutComponent,
    ServicesComponent,
    TalleresComponent,
    ColaboracionesComponent,
    TestimonialsComponent,
    FaqsComponent,
    CtaComponent,
    ImagesStripComponent,
    ContactComponent,
    FooterComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
